import { useState } from "react";
import { Download, Loader2 } from "lucide-react";
import { toast } from "sonner";
import api from "../../lib/api";
import { Button } from "../ui/button";

const FILE_NAMES = { decisions: "decisions", meetings: "reunions", risks: "risques" };

// CSV of a register (governance:export): what the list already shows, never a text. The download is journalled by the server.
export default function ExportButton({ kind, label = "Exporter (CSV)" }) {
  const [busy, setBusy] = useState(false);
  const download = async () => {
    setBusy(true);
    try {
      const { data } = await api.get(`/governance/export/${kind}.csv`, { responseType: "blob" });
      const url = URL.createObjectURL(data);
      const link = document.createElement("a");
      link.href = url;
      link.download = `jamora-${FILE_NAMES[kind]}.csv`;
      document.body.appendChild(link);
      link.click();
      link.remove();
      setTimeout(() => URL.revokeObjectURL(url), 1000);
    } catch (e) {
      toast.error(e?.response?.status === 403 ? "Vous n'avez pas accès à cet export." : "Impossible de télécharger l'export. Réessayez dans quelques instants.");
    } finally {
      setBusy(false);
    }
  };
  return (
    <Button type="button" variant="outline" onClick={download} disabled={busy} data-testid={`export-${kind}`}>
      {busy ? <Loader2 size={16} className="mr-1.5 animate-spin" aria-hidden="true" /> : <Download size={16} className="mr-1.5" aria-hidden="true" />}{label}
    </Button>
  );
}
